import { Box, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/lib/Theme/theme";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";
import { TravelBlockPage } from "@src/appV2/TravelBlocks/Page";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function TravelBlocksPage() {
  const worker = useDefinedWorker();

  return (
    <ThemeProvider theme={getTheme("light")}>
      <Box
        sx={{
          ...getSafeAreaPaddings({ top: true }),
          height: "100%",
        }}
      >
        <TravelBlockPage worker={worker} />
      </Box>
    </ThemeProvider>
  );
}
